module.exports = __webpack_public_path__ + "img/design proposal_demo-09.f8a68942.jpg";